import LazyLoad from 'vanilla-lazyload/dist/lazyload.esm.min';

export default function initLazyload() {
    const ll = new LazyLoad({
        elements_selector: '.image-container img',
        thresholds: '100% 0px',
        callback_loaded($el) {
            const $parent = $el.closest('.image-container');
            $parent?.classList.add('loaded');

            if (typeof setScrollToLastClickedTableOfContentsHref !== 'undefined') {
                setScrollToLastClickedTableOfContentsHref();
            }
        }
    });

    // используем IntersectionObserver для бесконечного скролла постов в блоге
    new LazyLoad({
        elements_selector: '.page__controls',
        threshold: 500,
        unobserve_completed: false,
        callback_enter() {
            MNTK.emit('renderNextBlogPost');
        }
    });

    function updateLazyLoadImages() {
        ll.update();
    }

    document.addEventListener('updateLazyLoadImages', updateLazyLoadImages);
}
